/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAssetTypeRequestDto } from './CreateAssetTypeRequestDto';
import {
    CreateAssetTypeRequestDtoFromJSON,
    CreateAssetTypeRequestDtoFromJSONTyped,
    CreateAssetTypeRequestDtoToJSON,
    CreateAssetTypeRequestDtoToJSONTyped,
} from './CreateAssetTypeRequestDto';

/**
 * 
 * @export
 * @interface BatchImportAssetTypesRequestDto
 */
export interface BatchImportAssetTypesRequestDto {
    /**
     * Array of asset types to import
     * @type {Array<CreateAssetTypeRequestDto>}
     * @memberof BatchImportAssetTypesRequestDto
     */
    items: Array<CreateAssetTypeRequestDto>;
}

/**
 * Check if a given object implements the BatchImportAssetTypesRequestDto interface.
 */
export function instanceOfBatchImportAssetTypesRequestDto(value: object): value is BatchImportAssetTypesRequestDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BatchImportAssetTypesRequestDtoFromJSON(json: any): BatchImportAssetTypesRequestDto {
    return BatchImportAssetTypesRequestDtoFromJSONTyped(json, false);
}

export function BatchImportAssetTypesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchImportAssetTypesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CreateAssetTypeRequestDtoFromJSON)),
    };
}

export function BatchImportAssetTypesRequestDtoToJSON(json: any): BatchImportAssetTypesRequestDto {
    return BatchImportAssetTypesRequestDtoToJSONTyped(json, false);
}

export function BatchImportAssetTypesRequestDtoToJSONTyped(value?: BatchImportAssetTypesRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CreateAssetTypeRequestDtoToJSON)),
    };
}

